/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { config as wechatConfig, share as wechatShare } from "@utils/wechat";

import Seo from "@components/seo";
import Lottie from "@components/lottie";
import Container from "@components/container";

import "slick-carousel/slick/slick.css";
import styles from "./index.module.scss";

import logoImage from "@images/logo.png";
import supportsImage from "@images/supports.png";

import back from "@images/animation/back/back.json";
// import back1 from "@images/animation/back/back add1.json";
// import back2 from "@images/animation/back/back add2.json";

const Layout = ({ children, location }) => {
  useEffect(() => {
    wechatConfig();
    wechatShare();
  }, []);
  return (
    <>
      {[back].map(m => {
        return (
          <Lottie
            key={back}
            animationData={m}
            className={styles.bg}
            config={{
              rendererSettings: { preserveAspectRatio: "xMinYMin slice" }
            }}
          />
        );
      })}
      <Seo />
      <div className={styles.body}>
        <div className={styles.container}>
          <main>{children}</main>
        </div>
        <footer className={styles.footer}>
          <div className={styles.logos}>
            <img src={logoImage} alt="logo" />
            <Container>
              <img className="fluidImage" src={supportsImage} alt="主办方" />
            </Container>
          </div>
          <p>2020 GFEST BY GCORES. ALL RIGHTS RESERVED.</p>
        </footer>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
